import React from 'react';
interface Bonus {
  icon: string;
  shortTitle: string;
  title: string;
  value: string;
  desc: string;
  spine: string;
  cover: string;
  accent: string;
}
const BONUSES: Bonus[] = [{
  icon: '📊',
  shortTitle: 'Planilla de Notas',
  title: 'Bonus 1 — La Planilla Maestra de Notas',
  value: '$6.990',
  desc: 'Google Sheets con fórmulas automáticas que gestiona 200 alumnos en 15 minutos semanales. Semáforo de riesgo, promedios automáticos y reporte listo para administración.',
  spine: '#3f6f52',
  cover: '#4d8462',
  accent: '#dff0e4'
}, {
  icon: '🤖',
  shortTitle: 'IA para Docentes',
  title: 'Bonus 2 — IA para Docentes de Ciencias',
  value: '$5.990',
  desc: 'Los 20 prompts maestros para usar ChatGPT como asistente de biología. Generá exámenes, actividades y rúbricas en 2 minutos.',
  spine: '#1e4b7a',
  cover: '#2563a8',
  accent: '#dbe9f7'
}, {
  icon: '📋',
  shortTitle: 'Banco de Rúbricas',
  title: 'Bonus 3 — El Banco Maestro de Rúbricas',
  value: '$4.990',
  desc: '9 rúbricas listas para evaluar TPs, informes, exposiciones orales, carpetas y proyectos. Con criterios claros que eliminan los reclamos.',
  spine: '#8a5a1e',
  cover: '#b9772a',
  accent: '#f6e8d3'
}, {
  icon: '🚦',
  shortTitle: 'Seguimiento',
  title: 'Bonus 4 — Pack de Seguimiento de Alumnos',
  value: '$5.990',
  desc: 'Detectá rápido quién está en riesgo antes de que sea tarde. Semáforo visual, fichas individuales y registro de intervenciones.',
  spine: '#7a2f3a',
  cover: '#a83f4d',
  accent: '#f6dde0'
}, {
  icon: '📝',
  shortTitle: 'Recuperatorios',
  title: 'Bonus 5 — Plantillas de Recuperatorios',
  value: '$5.990',
  desc: '6 modelos listos para armar recuperatorios, segundas instancias y evaluaciones para ausentes en menos de 15 minutos.',
  spine: '#4b3a7a',
  cover: '#6a54a8',
  accent: '#e6e0f6'
}, {
  icon: '🗓️',
  shortTitle: 'Organización Semanal',
  title: 'Bonus 6 — Organización Semanal Docente',
  value: '$4.990',
  desc: 'Sistema visual para planificar la semana en 10 minutos el domingo. Sin caos mental, sin olvidos y sin llegar al lunes con miedo.',
  spine: '#1c5f5b',
  cover: '#268079',
  accent: '#d6efec'
}];
// Book-cover mockup, generated with CSS (inspired by the reference layout)
function BonusCover({
  bonus,
  index
}: {
  bonus: Bonus;
  index: number;
}) {
  return <div className="relative mx-auto w-40 sm:w-44" data-id="element-260">
      <div className="relative rounded-lg overflow-hidden shadow-xl aspect-[3/4] flex flex-col p-4 text-white" style={{
      backgroundColor: bonus.cover
    }} data-id="element-261">
        {/* Spine */}
        <div className="absolute inset-y-0 left-0 w-3" style={{
        backgroundColor: bonus.spine
      }} data-id="element-262" />
        <div className="text-3xl mb-2 pl-2" data-id="element-263">{bonus.icon}</div>
        <div className="pl-2" data-id="element-264">
          <p className="text-[10px] font-semibold tracking-widest uppercase opacity-70" data-id="element-265">
            Bonus {index + 1}
          </p>
          <p className="text-lg font-extrabold leading-tight mt-1" data-id="element-266">
            {bonus.shortTitle}
          </p>
        </div>
        <div className="mt-auto pl-2" data-id="element-267">
          <div className="h-px w-10 bg-white/40 mb-2" data-id="element-268" />
          <p className="text-[10px] font-bold tracking-widest" data-id="element-269">
            BIOLOGÍA 360™
          </p>
        </div>
      </div>
    </div>;
}
export function BonusSection() {
  return <section className="py-16 md:py-20 bg-[#f7f4ef] px-4" data-id="element-270">
      <div className="max-w-6xl mx-auto" data-id="element-271">
        <div className="text-center mb-12 md:mb-14" data-id="element-272">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight" data-id="element-273">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-gray-500 mb-7 max-w-xl mx-auto" data-id="element-274">
            Incluidos sin costo extra · Valor real $34.940 ARS
          </p>
          <div className="inline-flex items-center gap-2 bg-[#c07a5b] text-white font-bold text-base md:text-lg px-7 py-3 rounded-full shadow-sm" data-id="element-275">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-276">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-white rounded-3xl shadow-sm hover:shadow-md transition-shadow p-8 flex flex-col items-center text-center" data-id="element-277">
              <BonusCover bonus={bonus} index={idx} data-id="element-278" />

              <span className="mt-6 inline-block text-sm font-bold tracking-wide px-4 py-1.5 rounded-full text-green-700" style={{
            backgroundColor: '#dcf5e3'
          }} data-id="element-279">
                GRATIS
              </span>

              <h3 className="mt-4 text-xl md:text-2xl font-extrabold text-gray-900 leading-snug" data-id="element-280">
                {bonus.icon} {bonus.title}
              </h3>

              <p className="mt-1 text-sm font-semibold text-gray-400 line-through" data-id="element-281">
                Valor: {bonus.value}
              </p>

              <p className="mt-3 text-base text-gray-500 leading-relaxed" data-id="element-282">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}